export default "__VITE_ASSET__DAi0VfhG__"